<template>
	<div v-if="body_show">
		<div>
      <div class="task-box task2">
        <div class="task-title">
          {{ pjtTitle }}
        </div>
        <div v-for="(item, index) in dynamicData" :class="[item.type === 'select2' ? 'in-block' : '', 'task2 task-plr-reset']">
          <!-- fill -->
          <div v-if="item.type === 'fill'" class="task_f">
            <h3 class="label">{{ item.label }}</h3>
            <div class="clearfix">
              <div v-if="item.yield" v-for="item2 in item.list" class="task_ninput pull-left">
                <span v-if="!item2.attr">{{item2.label}}</span>
                <input v-if="item2.attr" v-model="item2.value" type="text" class="task_n" />
                <span v-if="item2.attr">{{item2.label}}</span>
              </div>
            </div>
          </div>
          <!-- title -->
          <div v-if="item.type === 'title'" class="task_f">
            <h3 class="label">{{ item.label }}<span v-if="item.config">{{item.config.subtitle.text}}</span></h3>
          </div>
          <!-- tip -->
          <div v-if="item.type === 'tips'" class="task_f">
            <h3 class="label">{{item.label}}
              <span v-for="item2 in item.list" @click="showTagModul(item2.tip, item2.lab, item2.val)" :class="item2.tip ? 'noun' : ''">{{item2.tip ? item2.lab : item2}}</span>
            </h3>
          </div>
          <!-- select1 -->
          <div v-if="item.type === 'select1'" class="cell project4-task-row clearfix">
            <div v-for="item2 in item.list" class="pull-left">
              <van-cell-group v-if="item2.attr" class="grouping project3-task1 pull-left clearfix">
                <van-field v-model="item2.value" @click="showPicker(item2.select, item2)" readonly />
                <label class="choose_lable"></label>
              </van-cell-group>
              <span v-if="item2.attr" class="pull-left">{{item2.label}}</span>
              <span v-else class="pull-left">{{item2.label}}</span>
            </div>
          </div>
          <!-- select2 -->
          <div v-if="item.type === 'select2'" class="cell project4-task-row clearfix">
            <span class="pull-left">{{item.label}}</span>
            <van-cell-group class="grouping project3-task1 mt-reset pull-left clearfix">
              <van-field v-model="item.value" @click="showPicker(item.select, item)" readonly />
              <label class="choose_lable"></label>
            </van-cell-group>
          </div>
          <!-- textarea -->
          <div v-if="item.type === 'textarea'" class="cell clearfix">
            <div class="task_f clearfix">
              <h3 class="label task_pb10">{{item.label}}<span v-if="item.tips">{{item.tips}}</span></h3>
              <div class="input-mt mt-reset">
                <textarea v-model="item.value" @input="changeVal($event, item, item.config.length)" :placeholder="item.config.tips"></textarea>
              </div>
              <span class="float">{{item.value.length}}/{{item.config.length}}</span>
            </div>
          </div>
          <!-- text -->
          <div v-if="item.type === 'text'" class="cell clearfix">
            <div class="task_f clearfix">
              <h3 class="label task_pb10">{{item.label}}<span v-if="item.tips">{{item.tips}}</span></h3>
              <div class="input-mt input-box mt-reset">
                <input v-model="item.value" type="text" @input="changeVal($event, item, item.config.length)" :placeholder="item.config.tips" />
              </div>
              <span class="float">{{item.value.length}}/{{item.config.length}}</span>
            </div>
          </div>
          <!--  -->
        </div>
        <div class="submitBtn">
          <van-button @click="dynDataSub"  :class="verification() ? 'actice' : ''">提交</van-button>
        </div>
        <!-- 选择 -->
        <van-popup v-model="picker_show" position="bottom">
          <van-picker show-toolbar :columns="selectList" @cancel="picker_show = false" @confirm="confirm" />
        </van-popup>
        <!-- 弹出标签 -->
        <van-popup class="explain" v-model="tagModul">
          <div>
            <h2>{{ tagModulData.title }}</h2>
            <div class="pps" v-html="tagModulData.content"></div>
          </div>
        </van-popup>
      </div>
    </div>
	</div>
</template>
<script>
	import { index, subtable, getprofession, getjob } from '@/api/course'
	import { shareCon } from "@/utils/wxconfig"
	export default {
		data(){
			return {
				body_show: false,
				//
				pjtTitle: "",
				//
        dynamicData: [],
        form_id: '',
        tagModul: false,
        picker_show: false,
        tagModulData: {
            title: "默认标题",
            content: "默认标签提示内容"
        },
        selectItem: null,
        backupList: {},
        selectList: [],
        //
        objArg: {
          cid: "",
          cpid: ""
      	}
			}
		},
		methods: {
			dynDataSub(){
				let testResult = this.verification();
        if(!testResult){
            return
        }
        // loading
        this.$toast.loading({
            mask: true,
            message: "加载中..."
        });
        // 成立
        let getData = this.getDynData();
        // console.log(JSON.stringify(getData));
        let q = this.$route.query;
        subtable({
            cid: q.cid,
            type: "taskone",
            cpid: q.pid,
            cptid: q.id,
            form_id: this.form_id,
            field: JSON.stringify(getData)
        })
        .then((data) => {
            let q = this.$route.query;
            this.$toast.clear();
            // 下一个任务
            this.$router.push({path:'/project_alone_task2',query:{cid: q.cid, pid: q.pid, id: Number(q.id) + 1}});
        })
			},
			getDynData(){
        let newData = []
        for(let arg of this.dynamicData){
          if(arg.type === 'fill' || arg.type === 'select1'){
              let conJson = {};
              for(let item of arg.list){
                if(item.attr){
                  conJson[item.attr] = item.value
                }
              }
              newData.push({
                'field_id': arg.id,
                'content': JSON.stringify(conJson)
              })
          }else if(arg.type === 'select2' || arg.type === 'textarea' || arg.type === 'text'){
            newData.push({
              'field_id': arg.id,
              'content': arg.value
            })
          }
        }
        return newData
      },
			verification(){
        for(let arg of this.dynamicData){
          if(arg.type === 'fill' || arg.type === 'select1'){
            for(let arg2 of arg.list){
              if(arg2.attr && !arg2.value){
                return
              }
            }
          }else if(arg.type === 'select2' || arg.type === 'textarea' || arg.type === 'text'){
            if(!arg.value){
              return
            }
            if(arg.type === 'textarea' && arg.value.length > arg.config.length){
              return
            }
          }
        }
        return true
      },
      showTagModul(bool, title, content){
        if(!bool){
            return
        }
        this.tagModul = true;
        this.tagModulData['title'] = title;
        this.tagModulData['content'] = content;
      },
			changeVal(ev, item, maxLen){
				let tarLen = ev.target.value.length;
        if(tarLen > maxLen){
          item.value = item.value.substring(0, maxLen);
        }
			},
			pullData(){
				let q = this.$route.query;
				index({
					cid: q.cid,
          cpid: q.pid,
          cptid: q.id
				})
				.then((data) => {

					this.pjtTitle = data.title;
					this.dynamicData = [];
					let isReset = !!data.userfield.length;

					let userData = data.userfield;
          let newJSON = {};

          for(let arg of userData){
            newJSON[arg.field_id] = arg.content;
          }

          // 没有编辑过
          let list = data.field;
          this.form_id = list[0].form_id;
          // 取默认数据
          for(let [i1, arg] of list.entries()){
            if(arg.type === 'fill'){
              // 存key
              let nk = {};
              for(let [index, arg2] of arg.config.text.entries()){
                if(arg2.attr){
                  arg2.value = '';
                  nk[arg2.attr] = index;
                }
                if(!isReset && arg2.attr){
                  arg2.value = arg.config.variable[arg2.attr].content;
                }
              }
              let nd = {
                id: arg.id,
                type: 'fill',
                yield: true,
                label: arg.label,
                back: nk,
                list: arg.config.text
              };
              if(isReset){
                let sc = JSON.parse(newJSON[nd.id]);
                for(let attr in nk){
                  let index = nk[attr];
                  let value = sc[attr];
                  nd.list[index].value = value;
                }
              }
              this.dynamicData.push(nd)
            }else if(arg.type === 'title'){
              this.dynamicData.push({
                id: arg.id,
                type: 'title',
                yield: false,
                config: arg.config,
                label: arg.label
              })
            }else if(arg.type === 'tips'){
              let j = arg.config.subtitle.difficult;
              let t = arg.config.subtitle.text;
              let key;
              for(let attr in j){
                key = attr;
              }
              let arr = t.split(key);
              arr[2] = arr[1];
              arr[1] = {
                tip: true,
                lab: key,
                val: j[key].content.replace(/\n/ig, '<br/>')
              }
              this.dynamicData.push({
                id: arg.id,
                type: 'tips',
                yield: true,
                label: arg.label,
                list: arr
              })
            }else if(arg.type === 'select'){
              let text = arg.config.text;
              let json = arg.config.variable;
              // 多项
              if(text){
                let nk = {}
                for(let [index, arg2] of text.entries()){
                  if(arg2.attr){
                    arg2.value = '';
                    arg2.select = json[arg2.attr].content;
                    nk[arg2.attr] = index;
                  }
                }
                let nd = {
                  id: arg.id,
                  type: 'select1',
                  yield: true,
                  back: nk,
                  list: text
                }
                if(isReset){
                  let sc = JSON.parse(newJSON[nd.id]);
                  for(let attr in nk){
                    let index = nk[attr];
                    let value = sc[attr];
                    nd.list[index].value = value;
                  }
                }
                this.dynamicData.push(nd)
              }else{
                let nd = {
                  id: arg.id,
                  type: 'select2',
                  yield: false,
                  value: '',
                  label: arg.label,
                  select: arg.config.content
                }
                if(isReset  && data.userfield[i1]){
                  nd.value = newJSON[nd.id]
                }
                this.dynamicData.push(nd)
              }
            }else if(arg.type === 'textarea'){
              let nd = {
                id: arg.id,
                type: 'textarea',
                yield: false,
                label: arg.label,
                tips: arg.config.subtitle ? arg.config.subtitle.text : false,
                value: '',
                config: {
                  tips: arg.config.placeholder,
                  length: arg.config.word
                }
              }
              if(isReset){
                  nd.value = newJSON[nd.id] || '';
              }
              this.dynamicData.push(nd)
            }else if(arg.type === 'text'){
              let nd = {
                id: arg.id,
                label: arg.label,
                type: 'text',
                value: '',
                config: {
                  tips: arg.config.placeholder,
                  length: arg.config.word
                }
              }
              if(isReset){
                nd.value = newJSON[nd.id] || '';
              }
              this.dynamicData.push(nd);
            }
          }
          console.log(this.dynamicData);
          this.body_show = true;
				})
			}
		},
		created(){
			this.pullData();
			shareCon("course",this);
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/taskStyle.scss";
  .label{
    span{
      font-size: 0.32rem;
      color: #666;
    }
  }
  .task-box.task2{
    .task_f.mt-m{
      margin-top: 30px;
      h3{
          line-height: 1;
      }
    }
  }
  //
  .task-plr-reset{
    padding-left: 0;
    padding-right: 0;
  }
  .task_ninput{
    .task_n{
      width: 60px;
    }
  }
  .mt-reset{
    margin-top: 0!important;
  }
  .in-block{
    display: inline-block;
  }
  .task_pb10{
    padding-bottom: 10px;
  }
  .project4-task-row{
    color: #666;
    word-wrap: break-word;
    word-break: normal;
    span{
      height: 69px;
      line-height: 69px;
      padding: 0 10px;
      display: block;
    }
  }
</style>
<style>
	.project-alone-task1 .van-cell .van-cell__value input{
    width: 2.5rem;
  }
</style>